import React, { useState, useEffect } from 'react';
import { Container, Typography, Button, Box, Stack, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AddIcon from '@mui/icons-material/Add';
import { resumeService } from '../services/resume';
import { useNavigate } from 'react-router-dom';

const ResumeItem = ({ resume, onDelete }) => {
  const navigate = useNavigate();
  
  return (
    <Paper sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="h6">{resume.fileName || resume.name}</Typography>
          {resume.description && (
            <Typography variant="body2" color="text.secondary">
              {resume.description}
            </Typography>
          )}
          <Typography variant="caption" display="block" color="text.secondary">
            Created: {new Date(resume.createdAt).toLocaleDateString()}
          </Typography>
          <Typography variant="caption" display="block" color="text.secondary">
            Status: {resume.status}
          </Typography>
        </Box>
        <Box>
          <Button
            startIcon={<VisibilityIcon />}
            onClick={() => navigate(`/resumes/${resume.id}`)}
            sx={{ mr: 1 }}
            color="primary"
          >
            View Details
          </Button>
          {resume.url && (
            <Button
              startIcon={<PictureAsPdfIcon />}
              href={resume.url}
              target="_blank"
              sx={{ mr: 1 }}
            >
              View PDF
            </Button>
          )}
          <Button
            startIcon={<DeleteIcon />}
            color="error"
            onClick={() => onDelete(resume.id)}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

const Resumes = () => {
  const [resumes, setResumes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadResumes();
  }, []);

  const loadResumes = async () => {
    try {
      const data = await resumeService.getUserResumes();
      setResumes(data);
    } catch (error) {
      console.error('Failed to load resumes:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await resumeService.deleteResume(id);
      setResumes(resumes.filter(resume => resume.id !== id));
    } catch (error) {
      console.error('Failed to delete resume:', error);
    }
  };

  return (
    <Container sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          My Resumes
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/resumes/create')}
        >
          Create Resume
        </Button>
      </Box>

      <Stack spacing={2}>
        {resumes.map((resume) => (
          <ResumeItem
            key={resume.id}
            resume={resume}
            onDelete={handleDelete}
          />
        ))}
      </Stack>
    </Container>
  );
};

export default Resumes;
